let env, webirm_host;

const { isInProdHost } = window.__COMEIN_IR_STORE__;
export const isBuild = isInProdHost();

export const isAndroid = /Android/i.test(navigator.userAgent.toLowerCase());
export const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent.toLowerCase());
export const isMobile = isAndroid || isIOS;

function isMacEnv() {
	const ua = navigator.userAgent || '';
	const platform = navigator.platform || '';
	return /Mac/.test(platform) || /Mac OS/.test(ua);
}
export const isMac = isMacEnv();

// 环境区分
if (isBuild) {
	env = 'production';
	webirm_host = 'https://irm.comein.cn';
} else {
	env = 'development';
	webirm_host = 'https://testirm.comein.cn';
}

export const COMEIN_ENV = env;
export const WEBIRM_HOST = webirm_host;

// 历史访问导航缓存
export const CACHE_NAVIGATOR_HISTORY = 'APP_NAVIGATOR_HISTORY';
// 通用信息缓存
export const CACHE_TMPL_PAGE_TYPE = 'APP_TMPL_PAGE_TYPE';
export const CACHE_IR_VIRTUAL_SESSION = 'APP_IR_VIRTUAL_SESSION';
export const CACHE_IR_VIRTUAL_ID = 'APP_IR_VIRTUAL_ID';
export const CACHE_APP_ENTRY_URL = 'APP_ENTRY_URL';

export const WEBIRM_HOST_LIST = [
	'https://testirm.comein.cn',
	'https://irm.comein.cn',
	'https://testmobile.comein.cn',
	'https://mobile.comein.cn'
];

export const CACHE_APP_VERSION_KEY = 'APP_VERSION';
export const APP_VERSION_NUMBER = '1.3.1';

// 埋点相关
export const TRACK_SESSION = 'APP_TRACK_SESSION';
export const TRACK_SEQUENCE = 'APP_TRACK_SEQUENCE';
